import React, { useState } from 'react';
import { Paper, Typography, Button, Box } from '@mui/material';
import SortIcon from '@mui/icons-material/Sort';
import AddCommentIcon from '@mui/icons-material/AddComment';
import Comment from './Comment';

const CommentSection = () => {
  const [comments] = useState([
    {
      id: 1,
      author: 'CentristThinker',
      content: 'Interesting perspective on bipartisan solutions. I think we need more dialogue between different viewpoints to find common ground and workable solutions.',
      timestamp: new Date('2024-03-20T10:00:00'),
      likes: 15,
    }
  ]);

  return (
    <Paper sx={{ p: 4, boxShadow: '0 2px 12px rgba(0,0,0,0.1)' }}>
      <Typography 
        variant="h5" 
        gutterBottom
        sx={{ 
          color: 'primary.main',
          mb: 3
        }}
      >
        Discussion
      </Typography>

      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        mb: 4,
        gap: 2
      }}>
        <Button 
          variant="outlined" 
          startIcon={<SortIcon />}
          sx={{ 
            borderColor: 'divider',
            '&:hover': {
              borderColor: 'primary.main',
              backgroundColor: 'rgba(44, 62, 80, 0.04)'
            }
          }}
        >
          Sort by: Latest
        </Button>
        <Button 
          variant="contained" 
          color="secondary"
          startIcon={<AddCommentIcon />}
          sx={{ 
            px: 3,
            '&:hover': {
              backgroundColor: 'secondary.dark'
            }
          }}
        >
          New Thread
        </Button>
      </Box>

      <Box sx={{ mt: 3 }}>
        {comments.map((comment) => (
          <Comment key={comment.id} comment={comment} />
        ))}
      </Box>
    </Paper>
  );
};

export default CommentSection; 